<template>
    <div class="content-raw-data-wrapper">
        <v-expansion-panels flat v-model="showRawData">
            <v-expansion-panel>
                <v-expansion-panel-title>
                    <h3>JSON Data</h3>
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                    <div class="dialog-raw-data-content">
                        <p>{{ rawLeads }}</p>
                    </div>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
export default {
    props: {
        rawLeads: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showRawData: false,
            searchQuery: ''
        };
    },
    methods: {
        handleShowRawData() {
            this.showRawData = !this.showRawData;
        }
    }
};
</script>

<style lang="scss" scoped>

</style>